import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Synchronise <html lang> avec la langue active pour éviter que les
// extensions de traduction navigateur (Google Translate, Chrome auto-translate)
// ne corrompent les libellés rendus par i18n. Sans cela, un contenu FR sous
// `<html lang="en">` se fait re-traduire et produit "Accepteur" au lieu de
// "Accepter", "anciens" au lieu de "former", etc.
const applyHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.split('-')[0];
  }
};
applyHtmlLang(i18n.language || 'fr');
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
